<template>
    <v-row justify="center">
        <v-dialog v-model="showDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="headline pt-1 pr-1 custom-card-header">
                    Select Task Status
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="toggle"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <br />
                <v-card-text class="pb-1"> Select a new task status:</v-card-text>
                <br />
                <div class="px-5" v-for="status in statusOptions" :key="status">
                    <v-btn color="primary" block class="" @click="setStatus(status)">{{ status }}</v-btn>
                    <br />
                </div>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="primary" outlined class="ma-2" @click="toggle">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
    import { mapActions } from 'vuex'
    import Helpers from "@/utils/helpers/jobTaskHelpers"
    export default {
        data () {
            return {
                rawStatusOptions: Helpers.statuses,
            }
        },
        props: {
            showDialog: {
                type: Boolean,
                required: true
            },
            toggle: {
                type: Function,
                required: true
            },
            jobTask: {
                type: Object
            },
        },
        methods: {
            ...mapActions({
                updateTask: 'jobTasks/update'
            }),
            async setStatus (newStatus) {
                this.jobTask.status = newStatus

                // Need to reassign the tags before an update
                this.jobTask.tagIds = []
                this.jobTask.jobTaskTags.forEach(jtt => {
                    this.jobTask.tagIds.push(jtt.tagId)
                })

                await this.updateTask(this.jobTask)
                this.toggle()
            }
        },
        computed: {
            statusOptions() {
                // Idea: Don't show those two statuses, as they aren't useful for the user in the field?
                return this.rawStatusOptions.filter(status => status !== "Unassigned" && status !== "Reassigned")
            }
        }
    }
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
